module.exports = __webpack_public_path__ + "img/icon_to_login_keniu.7ab163a4.png";